window.PXUTheme.jsAchievementsCalculator = {
    init: function init($section) {
        Shopify.theme.jsAchievementsCalculator = $.extend(this, window.PXUTheme.getSectionData($section));

        if (!this.elements) {
            return
        }

        this.selectors = {
            counter: '[data-achievements-counter]'
        }

        this.default = {
            durationAnimation : 3 //sec
        }

        this.associateElements();
        this.initElements();
    },

    initElements: function initElements() {

        this.elements.forEach((element) => {

            if (!element.selector) {
                return null;
            }

            switch (element.type) {
                case "CarbonOffsetCo2":
                    element.api_number = this.kgToGramm(element);
                    element.number = this.calculation(element);
                    
                    element.symbLvL1 = 'g';
                    element.SymbLvL2 = 'KG';
                    element.SymbLvL3 = 'MT';
                    element.format = true;

                    break;
                case "WaterSaved":
                    element.api_number = this.kgToGramm(element);
                    element.number = this.calculation(element);
                    
                    element.SymbLvL2 = 'K';
                    element.SymbLvL3 = 'M+';
                    element.format = true;


                    break;
                case "BottlesPlastic":
                    element.api_number = this.kgToGramm(element);
                    element.number = this.calculation(element);
                    element.digits = 1;
                    element.SymbLvL2 = 'K';
                    element.SymbLvL3 = 'M+';
                    element.format = true;


                    break;
                case "Trees":
                    element.number = this.calculation(element);
                    element.format = false;

                    break;

                case "CommunitiesPeople":
                    element.format = false;
                    element.number = Math.round(element.additional_number);

                    break;
                default:
                    break;
            }

            this.startCounter(element)

        })
    },

    roundNumber(n) {
        let k =  n / 1000;
        if (k > 1) {
            return n
        }

        if (k < 1) {
            return 1000
        }
    },

    kgToGramm: function kgToGramm(element) {
      return element.api_number * 1000;
    },

    calcDigits: function calcDigits(n) {
        n = n/1000;
        if (n > 1000)
            return 2;
        if (n > 1)
            return 0;
        if (n < 1)
            return 0;
    },

    calculation: function calculation(element) {

        if (!element.additional_number) {
            return Math.round(parseFloat(element.api_number));
        }

        return Math.round(parseFloat(element.additional_number) + parseFloat(element.api_number));
    },

    associateElements: function associateElements() {
        this.elements.forEach((element) => {
            element.selector = document.querySelector(`[data-achievements-type="${element.type}"]`)
        })
    },

    startCounter: function startCounter(element) {
        let countElement = element.selector.querySelector(this.selectors.counter)
        this.animateValue(countElement, element.number,element)

    },

    animateValue: function animateValue(element, finalValue, parameters) {
        const step = (t, elapsed) => {
            t = t*t*t;

            let value = finalValue * t;

            if( t > 0.999 )
                value = finalValue;

            element.innerHTML = value | 0;
        }

        const done = () => {
            element.innerHTML = parameters.format ? Shopify.theme.jsAchievementsCalculator.nFormatter(
                finalValue,
                parameters.digits,
                parameters.symbLvL1,
                parameters.SymbLvL2,
                parameters.SymbLvL3) : this.numberWithCommas(finalValue);
        }

        let settings = {
            step     : step,
            duration : this.default.durationAnimation,
            done     : done,
            fps      : 60
        }

        const task = new FrameAnimationCounter(settings)
        task.start()
    },

    numberWithCommas:function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    nFormatter:function nFormatter(num, digits, symbLvL1,SymbLvL2,SymbLvL3) {
        let si = [
            { value: 1, symbol: symbLvL1 || "" },
            { value: 1E3, symbol: SymbLvL2 || "" },
            { value: 1E6, symbol: SymbLvL3 || "" }
        ];
        let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        let i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    },

    type: function type(){

    },

    unload: function unload() {

    }
};

